import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useDeleteProjectModule = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(async ({ moduleId, projectId }) => {
    return await axios.delete(`/standardization/${projectId}/modules/${moduleId}`);
  });

  const deleteModule = (moduleId, projectId, options) => {
    mutate(
      { moduleId, projectId },
      {
        onSuccess: (res) => {
          if (!res.data) {
            toast.error(`The module can not be deleted! `);
            return;
          }
          options.onSuccess && options.onSuccess(moduleId);
        },
      }
    );
  };

  return {
    deleteModule,
    isLoading,
  };
};

export default useDeleteProjectModule;
